export const STAFF_STATE_OPTIONS = [
    {id: "applicant", name: "Applicant"},
    {id: "employee", name: "Employee"},
    {id: "ex-employee", name: "Ex-employee"},
    {id: "supervisor", name: "Supervisor"}
]
